function updateMyShippingBar() {
  const bar = document.querySelector('.my-shipping-progress');
  if (!bar) return;

  // Convert threshold to cents
  const thresholdCents = parseFloat(bar.dataset.threshold) * 100;
  const totalCents = parseFloat(bar.dataset.total);

  const fill = bar.querySelector('.my-progress-fill');
  if (!fill) return;

  // Calculate percent fill
  const percent = Math.min((totalCents / thresholdCents) * 100, 100);
  fill.style.width = percent + "%";

  // Calculate remaining amount
  const remainingCents = Math.max(thresholdCents - totalCents, 0);
  const remainingFormatted = `$${(remainingCents / 100).toFixed(2)}`;

  // Update fill text (optional inside the bar)
  fill.textContent = remainingFormatted;

  // Update the free shipping message
  const messageSpan = document.querySelector('.free-shipping-bar .text-subdued');
  if (messageSpan) {
    if (remainingCents > 0) {
      messageSpan.textContent = `Spend ${remainingFormatted} more and get free shipping!`;
      bar.classList.remove('is-filled');
      bar.classList.add('not-filled');
    } else {
      messageSpan.textContent = `You have free shipping!`;
      bar.classList.add('is-filled');
      bar.classList.remove('not-filled');
    }
  }
}

// Initial load
updateMyShippingBar();

// Update on cart change
document.addEventListener("cart:change", (e) => {
  requestAnimationFrame(() => {
    const bar = document.querySelector('.my-shipping-progress');
    if (bar) {
      const cart = e.detail.cart;

      const itemsTotal = cart.items
        .filter(i => i.requires_shipping)
        .reduce((sum, i) => sum + i.final_line_price, 0);

      const discount = cart.cart_level_discount_applications
        .reduce((sum, d) => sum + d.total_allocated_amount, 0);

      bar.dataset.total = itemsTotal - discount;
    }

    updateMyShippingBar();
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const observeQuickBuy = new MutationObserver(() => {
    const modal = document.querySelector(".quick-buy-modal");
    const afterpayEl = modal?.querySelector(".afterpay-placement");

    if (afterpayEl && window.AfterpayMessagingLib) {
      try {
        window.AfterpayMessagingLib.refresh();
      } catch (e) {
        console.warn("Afterpay messaging refresh failed:", e);
      }
    }
  });

  observeQuickBuy.observe(document.body, { childList: true, subtree: true });
});